var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Visualizando Documento: "+_vm._s(_vm.name))]),(_vm.fileUrl)?_c('iframe',{attrs:{"src":_vm.fileUrl,"width":"100%","height":"600px"}}):_c('p',[_vm._v("Carregando documento...")])])}
var staticRenderFns = []

export { render, staticRenderFns }